import {SET_SUBSCRIPTIONS, SET_USERS_TOKENS_UTILIZATION, SET_SUBSCRIPTIONS_LOADING, SET_SUBSCRIPTIONS_ERROR, SET_TOPUP_PLANS, SET_TOPUP_PLANS_LOADING, SET_TOPUP_PLANS_ERROR, SET_USERS_BALANCE_LOADING, SET_USERS_BALANCE_ERROR} from "../actions/meta.action";
import {IActionModel} from "../../models/action.model";

export interface IUserBalanceModel {
    total_budget: number;
    user_used_budget: number;
    user_remaining_budget: number;
    gift_credits: number;
    subscription_credits: number;
    topup_credits: number;
}

export interface ITopupPlanModel {
    id: string;
    plan_name: string;
    plan_name_tag: string;
    plan_interval: string;
    plan_details: {
        description: string;
        features: string[];
        cost_structure: {
            [key: string]: {
                currency: string;
                amount: number;
                providers: {
                    [key: string]: {
                        plan_id: string | null;
                        is_active: boolean;
                    };
                };
            };
        };
    };
    is_public_plan: boolean;
    allowed_spend_budget_USD: number;
    is_topup_plan: boolean;
    is_domestic: boolean;
    created_at: string;
    updated_at: string;
}

export interface IMetaReducerState {
    subscriptions?: [];
    subscriptionsLoading?: boolean;
    subscriptionsError?: string | null;
    topupPlans?: ITopupPlanModel[];
    topupPlansLoading?: boolean;
    topupPlansError?: string | null;
    usersBalance?: IUserBalanceModel;
    usersBalanceLoading?: boolean;
    usersBalanceError?: string | null;
}

const INITIAL_STATE: IMetaReducerState = {
    subscriptions: [],
    subscriptionsLoading: false,
    subscriptionsError: null,
    topupPlans: [],
    topupPlansLoading: false,
    topupPlansError: null,
    usersBalance: {
        total_budget: 0,
        user_used_budget: 0,
        user_remaining_budget: 0,
        gift_credits: 0,
        subscription_credits: 0,
        topup_credits: 0,
    },
    usersBalanceLoading: true,
    usersBalanceError: null,
};


const metaReducer = (state: IMetaReducerState = INITIAL_STATE, action: IActionModel): IMetaReducerState => {
    switch (action.type) {
        case SET_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptions: action.payload,
            };
        case SET_SUBSCRIPTIONS_LOADING:
            return {
                ...state,
                subscriptionsLoading: action.payload,
            };
        case SET_SUBSCRIPTIONS_ERROR:
            return {
                ...state,
                subscriptionsError: action.payload,
            };
        case SET_USERS_TOKENS_UTILIZATION:
            return {
                ...state,
                usersBalance: action.payload,
                usersBalanceError: null,
            };
        case SET_USERS_BALANCE_LOADING:
            return {
                ...state,
                usersBalanceLoading: action.payload,
            };
        case SET_USERS_BALANCE_ERROR:
            return {
                ...state,
                usersBalanceError: action.payload,
            };
        case SET_TOPUP_PLANS:
            return {
                ...state,
                topupPlans: action.payload,
                topupPlansLoading: false,
                topupPlansError: null,
            };
        case SET_TOPUP_PLANS_LOADING:
            return {
                ...state,
                topupPlansLoading: action.payload,
            };
        case SET_TOPUP_PLANS_ERROR:
            return {
                ...state,
                topupPlansError: action.payload,
                topupPlansLoading: false,
            };
        default:
            return state;
    }
};

export default metaReducer;

